import { Badge } from '@indipia/ui-core';
import type { CustReqReportItem } from '../../types/custReqReport.types';
import { CUST_REQ_REPORT_MESSAGE as MSG, countSummary, summaryText, summaryTone } from './custReqReport.logic';

/**
 * [검수완료]·[조치완료] 확인 팝업의 고객 요청 목록 — 기획 004 D.
 * 반영된 요청(✓)과 체크 없는 요청(⚠)을 한눈에 보여 주고, 요청이 없으면 아무것도 그리지 않는다.
 */
export function CustReqConfirmList({ items }: { items: CustReqReportItem[] | undefined }) {
  if (!items || items.length === 0) return null;
  const summary = countSummary(items);
  return (
    <div className="mt-3">
      <Badge status={summaryTone(summary)}>{summaryText(summary)}</Badge>
      <ul className="mt-2 space-y-1">
        {items.map((r, idx) => (
          <li key={r.custReqId} className="flex items-start gap-2 text-body-sm">
            <span className="shrink-0 text-text-muted">{idx + 1}</span>
            <span
              className="min-w-0 flex-1 text-text-secondary"
              style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'pre-line', wordBreak: 'break-word' }}
            >
              {r.content}
            </span>
            {r.applied
              ? <Badge status="success" className="shrink-0">✓ {MSG.applied}</Badge>
              : <Badge status="warning" className="shrink-0">⚠ {MSG.noCheckOwner}</Badge>}
          </li>
        ))}
      </ul>
      <p className="mt-2 text-caption text-text-muted">{MSG.confirmKeep}</p>
    </div>
  );
}
